import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';

function normalizeSmsMessage(value) {
  return String(value || '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/&nbsp;/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .trim();
}

const SMSPreview = ({
  message,
  openSMSPreview,
  setOpenSMSPreview,
  to = 'Selected Users',
}) => {
  const previewMessage = normalizeSmsMessage(message);
  const characterCount = previewMessage.length;
  const segmentCount = characterCount === 0 ? 0 : Math.ceil(characterCount / 160);

  return (
    <Dialog
      open={openSMSPreview}
      onClose={() => setOpenSMSPreview(false)}
      maxWidth="xs"
      fullWidth
      aria-labelledby="text-preview-dialog-title"
    >
      <DialogTitle id="text-preview-dialog-title">
        SMS Preview
      </DialogTitle>

      <DialogContent style={{ backgroundColor: '#f4f4f4', padding: 24 }}>
        <div
          style={{
            maxWidth: 360,
            margin: '0 auto',
            backgroundColor: '#ffffff',
            borderRadius: 24,
            border: '1px solid #ddd',
            padding: 16,
          }}
        >
          <Typography variant="caption" color="textSecondary">
            To: {to}
          </Typography>

          <div
            style={{
              marginTop: 16,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <div
              style={{
                maxWidth: '85%',
                padding: '10px 14px',
                borderRadius: 18,
                backgroundColor: '#e5e5ea',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: 14,
                lineHeight: 1.4,
              }}
            >
              {previewMessage || '(No message)'}
            </div>
          </div>

          <Divider style={{ margin: '16px 0' }} />

          <Typography variant="caption" color="textSecondary">
            Characters: {characterCount}
          </Typography>
          <br />
          <Typography variant="caption" color="textSecondary">
            Estimated SMS segments: {segmentCount}
          </Typography>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 16,
            }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={() => setOpenSMSPreview(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SMSPreview;